<script lang="ts" setup>
import { useVoipRoomStore } from '@stores/voip-room'

import LiveKitButtonCamera from '@Widgets/Classroom/LiveKit/LiveKitButtonCamera.vue'

defineOptions({
  name: 'ButtonCamera',
})

const voipRoomStore = useVoipRoomStore()
</script>

<template>
  <LiveKitButtonCamera v-if="voipRoomStore.isLiveKitRoom" />
</template>
